<template>
  <span class='kui-validatebox' :style="{width}">
    <slot name='validatebox-content'></slot>
    <span class="validatebox-message" v-show="isShowTips">{{validateMsg}}</span>
  </span>
</template>
<script>
import validatebox from "./src/validatebox";
export default validatebox;
</script>
<style lang='less'>
.kui-validatebox {
  position: relative;
  display: inline-block;
  .validatebox-message {
    color: #f56c6c;
    font-size: 12px;
    position: absolute;
    top: 100%;
    left: 0px;
    line-height: 1;
  }
  .validate-must input {
    border-color: #f56c6c !important;
  }
}
</style>






// WEBPACK FOOTER //
// src/lib/ui/default/validatebox/index.vue